import { createSlice } from '@reduxjs/toolkit';

const { reducer, actions } = createSlice({
  name: 'devices',
  initialState: {
    items: {},
    selectedId: null,
    filter: '',
  },
  reducers: {
    refresh(state, action) {
      state.items = {};
      action.payload.forEach((item) => {
        if (state.uniqueId != null) {
          if (item.uniqueId === state.uniqueId) {
            state.items[item.id] = item;
          }
        } else {
          state.items[item.id] = item;
        }
      });
    },
    update(state, action) {
      action.payload.forEach((item) => {
        state.items[item.id] = item;
      });
    },
    updateSingle(state, action) {
      const device = action.payload;
      // Update just this specific device in the store
      state.items[device.id] = device;
    },
    select(state, action) {
      state.selectedId = action.payload;
    },
    remove(state, action) {
      delete state.items[action.payload];
    },
    filter(state, action) {
      state.filter = action.payload.toUpperCase();
    },
  },
});

export { actions as devicesActions };
export { reducer as devicesReducer };
